import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import { toolbarStyles } from './styles';
import classNames from 'classnames';

function StyleButton (props) {

    const { classes, onToggle, control, active } = props;

    const handleClick = (e) => {
        e.preventDefault();
        onToggle(control.value);
    };

    const className = classNames(classes.root, { [classes.selected]: active });

    return (
        <>
            <IconButton
                disableRipple
                className={className}
                onMouseDown={handleClick}
            >
                <control.icon />
            </IconButton>
        </>
    )
}

export default withStyles(toolbarStyles)(StyleButton);
